import { type FC, useState } from 'react';
import { ModalActions, ModalContainer, ModalHeader } from '@/utils/modal';

interface ConfirmRegenerateCollectedSamplesModalProps {
  onClick: () => Promise<void>;
  closeModal: () => void;
}

/**
 * Confirmation modal shown when regenerating sample names with "include collected" enabled.
 * Warns that collected sample names that have been printed on labels may be affected.
 */
const ConfirmRegenerateCollectedSamplesModal: FC<ConfirmRegenerateCollectedSamplesModalProps> = ({
  onClick,
  closeModal,
}) => {
  const [busy, setBusy] = useState(false);

  const handleSubmit = async () => {
    setBusy(true);
    try {
      await onClick();
    } finally {
      setBusy(false);
    }
  };

  return (
    <ModalContainer size="narrow" testKey="confirm-regenerate-collected-samples">
      <ModalHeader
        title="Regenerate collected sample names?"
        closeModal={closeModal}
        className="pa3 bb b--moon-gray bg-white"
      />
      <div className="pa3 f6 dark-gray lh-copy">
        <p className="ma0">
          This will regenerate names for collected samples. Collected sample names that have been printed on labels may
          be affected.
        </p>
      </div>
      <div className="pa3 bt b--moon-gray">
        <ModalActions
          submitBtnText="Confirm"
          onSubmit={handleSubmit}
          submitButtonProps={{ disabled: busy }}
          cancelBtnText="Cancel"
          onCancel={closeModal}
        />
      </div>
    </ModalContainer>
  );
};

export default ConfirmRegenerateCollectedSamplesModal;
